/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ProfileImportItem } from './profileImportItem';
import type { ProfileImportRejected } from './profileImportRejected';

/**
 * Returned by POST /imports after multipart upload + workflow dispatch.
 */
export interface ProfileImportCreateResponse {
  imports: ProfileImportItem[];
  queued: number;
  rejected?: ProfileImportRejected[];
}
